import { render } from "./organisation-linking.vue?vue&type=template&id=6f72c3a2&ts=true"
import script from "./organisation-linking.ts?vue&type=script&lang=ts&external"
export * from "./organisation-linking.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__